// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CartPageTemplate, { CartPageTemplateStyles } from "@werner/App/Components/Cart/CartPageTemplate";
import XngZone from "@werner/App/Components/Common/XngZone";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

interface OrderDetailsLayoutStyles {
    cartPageTemplateStyles?: CartPageTemplateStyles;
    otherInfoWrapper?: InjectableCss;
}

const orderDetailsLayoutStyles: OrderDetailsLayoutStyles = {
    otherInfoWrapper: {
        css: css`
            margin-top: 54px;
        `,
    },
};

const styles = orderDetailsLayoutStyles;
const OrderDetailsLayout: FC<Props> = ({ id }) => {
    return (
        <CartPageTemplate extendedStyles={styles.cartPageTemplateStyles}>
            <CartPageTemplate.HeaderSection>
                <XngZone hint="Zone For Header Title" contentId={id} zoneName="OrderDetailsHeaderTitle" />
            </CartPageTemplate.HeaderSection>
            <CartPageTemplate.MainSection>
                <XngZone hint="Zone For Main Section" contentId={id} zoneName="Content" />
            </CartPageTemplate.MainSection>
            <CartPageTemplate.CartTotalSection>
                <XngZone hint="Zone For Cart Total" contentId={id} zoneName="OrderDetailsCartTotal" />
                <StyledWrapper {...styles.otherInfoWrapper}>
                    <XngZone hint="Zone For Sales Person Information" contentId={id} zoneName="SalesPersonInfo" />
                </StyledWrapper>
            </CartPageTemplate.CartTotalSection>
        </CartPageTemplate>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsLayout,
    definition: {
        group: "Xngage Custom" as any,
        displayName: "Order Details Layout",
    },
};

export default widgetModule;
